"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supplierInfoApi = supplierInfoApi;
exports.supplierUpdateApi = supplierUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取当前供应商信息
 */
function supplierInfoApi() {
  return (0, _request.default)({
    url: '/supplier/info',
    method: 'GET'
  });
}

/**
 * 更新当前供应商信息
 */
function supplierUpdateApi(data) {
  return (0, _request.default)({
    url: '/supplier/update',
    method: 'POST',
    data: data
  });
}